<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
			  <el-breadcrumb-item>历史开票</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="invoice">
			<h4>开票信息</h4>
			<el-table
			    :data="list"
			    stripe
			    style="width: 100%">
			    <el-table-column
			      prop="company_name"
			      label="公司名称"
			      width="260">
			    </el-table-column>
			    <el-table-column
			      prop="tax_id"
			      label="统一社会信用代码"
			      width="230">
			    </el-table-column>
			    <el-table-column
			      prop="create_time"
			      label="申请时间"
				  width="200">
			    </el-table-column>
				<el-table-column
				  prop="email"
				  label="接收邮箱"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="price"
				  label="开票金额"
				  width="150">
				</el-table-column>
				<el-table-column
				  prop="status"
				  label="开票状态"
				  width="136">
				   <template slot-scope="scope">
						<el-tag type="info" v-if="scope.row.status==1">待开票</el-tag>
						<el-tag type="warning" v-else>已开票</el-tag>
				   </template>
				  </el-table-column>
				</el-table-column>
			  </el-table>
		</div>
		<div class="fenye" if="total>10">
		   <el-pagination
			 background
			 @current-change="handleCurrentChange"
			 :current-page.sync="currentPage1"
			 :page-size="10"
			 layout="total, prev, pager, next ,jumper"
			 :total="total">
		   </el-pagination>
		</div>
	</div>
</template>
<script>
	import { InvoiceIndex } from "@/api/api.js"
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
		    tableData: [],
			page:1,
			limit:10,
			list:[],
			o_id:"",
			total:"",
			pagecount:"",
			currentPage1:""
			
	    }
	  },
	  created() {
	  	this.getlist()
	  },
	  methods: {
		handleCurrentChange(e){
		  	this.page=e
		  	this.getlist()
		},
		getlist(){
		   InvoiceIndex({
			   o_id:this.o_id,
			   page:this.page,
			   limit:'10'
		   }).then(res=>{
			   this.total=res.data.data.total
			   this.pagecount=res.data.data.pass_count
			   this.currentPage1=res.data.data.current_page
			   this.list=res.data.data.data
		   })
		}
	  },
	}
</script>
<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.fenye{
		width:100%;
		display:flex;
		align-items: center;
		justify-content: center;
		padding-bottom:20px;
	}
	.invoice{
		width:1200px;
		margin: 0 auto;
		padding:12px;
		box-sizing: border-box;
		background-color:#fff;
		box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.1);
		border-radius: 12px;
	}
	.invoice h4{
		font-weight: 800;
		font-size: 20px;
		color: #333333;
		margin-bottom:12px;
	}
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
		padding:60px 0px;
	}
</style>